import React from "react";
import "./ProfitComponent.css"; // Assuming your CSS file is named ProfitComponent.css

const ProfitComponent = () => {
  return (
    <>
      <div className="profit-container">
        <h1 className="profit-title">Open your Account & Get</h1>
        <div className="profit-highlight">
          <span className="profit-percentage">8% to 10% in Profit</span>
        </div>
        <h2 className="profit-subtitle">Each Month</h2>
        <div className="button-group">
          <button className="btn login-btn">Login</button>
          <button className="btn register-btn">Register</button>
        </div>
      </div>
    </>
  );
};

export default ProfitComponent;
